export default function HoverTip({ text, children, className = '', placement = 'top' }) {
  if (!text) return children;

  return (
    <span className={`hover-tip hover-tip--${placement}${className ? ` ${className}` : ''}`}>
      {children}
      <span className="hover-tip__bubble" role="tooltip">
        {text}
      </span>
    </span>
  );
}
